// ** React Imports
import { useEffect, useState, SyntheticEvent } from 'react'

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import TextField from '@mui/material/TextField'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import FormControl from '@mui/material/FormControl'
import HeaderResponsive from '../../../components/layouts/HeaderResponsive';
import { stickyListRegionWidth } from '../../../components/layouts/StickyListToolbar';
import { useDrawer } from '../../../components/context/DrawerContext';

// ** Third Party Imports

// ** Icons Imports

// ** Third Party Styles Imports
import 'react-datepicker/dist/react-datepicker.css'
import Box from '@mui/material/Box';
import Title from '../../../components/Title';

// import '../Login.css';
import axios from "axios"
import { useNavigate, Link } from 'react-router-dom';

interface ShowAlerts {
  showAlert: (message: string, severity?: 'success' | 'info' | 'warning' | 'error') => void;
  showLoading: () => void;
  hideLoading: () => void;
}
const UserAdd: React.FC<ShowAlerts> = ({ showAlert, showLoading, hideLoading }) => {
  const { drawerOpen } = useDrawer();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [firstname, setFirst_name] = useState('');
  const [lastname, setLast_name] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password_confirm, setPassword_confirm] = useState('');
  const [username, setUsername] = useState('');
  const [idnumber, setIdnumber] = useState('');
  const [phone, setPhone] = useState('');
  const [cellphone, setCellphone] = useState('');
  const [address, setAddress] = useState('');
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response && error.response.status === 401) {
          navigate('/login');
          return; // Salimos temprano y no devolvemos el error rechazado.
        }
      }
    );
    return () => {
      axios.interceptors.response.eject(interceptor);
    }
  }, [navigate]);

  const submit = async (event: SyntheticEvent) => {
    event.preventDefault();

    // Validar campos obligatorios
    if (!firstname || !lastname || !cellphone || !password || !password_confirm) {
      showAlert('Tiene campos pendientes por diligenciar', 'warning');
      return;
    }

    // Validar que las contraseñas coincidan
    if (password !== password_confirm) {
      showAlert('Las contraseñas no coinciden', 'warning');
      return;
    }

    showLoading();

    const formData = {
      firstname,
      lastname,
      idnumber,
      username,
      email,
      password,
      password_confirm,
      phone,
      cellphone,
      address,
      type_user_id: 1,
    };
    //console.log('formData', formData);
    // const formData = new FormData();
    const url = 'employees';

    try {
      // 1. Validar si el username ya existe
      const checkUsernameResponse = await axios.get(`users/check-username/${username}`);
      if (checkUsernameResponse.data.exists) {
        showAlert('El nombre de usuario ya está en uso', 'warning');
        return;
      }

      // 2. Si el username no existe, crear el usuario
      const response = await axios.post(url, formData);
      showAlert('Se ha realizado el registro exitosamente!', 'success');
      await new Promise((resolve) => setTimeout(resolve, 1000)); // Esperar 1 segundo
      navigate('/administrar/empleados');
    } catch (error) {
      showAlert('Error al realizar el registro', 'error');
    } finally {
      hideLoading();
    }
  };
  return (
    <HeaderResponsive>
      <Box display="flex" justifyContent="center" mb={1}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: (t) => stickyListRegionWidth(t, drawerOpen),
            maxWidth: '100%',
            boxSizing: 'border-box',
          }}
        >
          <Title>Crear Información Empleados</Title>
        </Box>
      </Box>
      <Card>
        <CardContent
          sx={{
            width: (t) => stickyListRegionWidth(t, drawerOpen),
            maxWidth: '100%',
            boxSizing: 'border-box',
            overflowX: 'auto',
          }}
        >
          <Divider sx={{ margin: 0 }} />
          <form onSubmit={(e) => e.preventDefault()} autoComplete="off">
            {/* Campos ocultos para engañar el autocompletado del navegador */}
            <input type="text" name="fake_user" style={{ display: 'none' }} autoComplete="username" />
            <input type="password" name="fake_pass" style={{ display: 'none' }} autoComplete="current-password" />

            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size='small'
                    type="number"
                    label="Número de Identificación"
                    placeholder="12233214576"
                    onChange={(event) => setIdnumber(event.target.value)}
                    inputProps={{ maxLength: 20 }}
                    required
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Nombre de usuario"
                    placeholder="Leonard"
                    size='small'
                    type="text"
                    name="new-user-field"
                    onChange={(event) => setUsername(event.target.value)}
                    inputProps={{ maxLength: 30 }}
                    required
                    autoComplete="new-username"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Nombres"
                    size='small'
                    placeholder="Leonard"
                    onChange={(event) => setFirst_name(event.target.value)}
                    inputProps={{ maxLength: 30 }}
                    required
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Apellidos"
                    size='small'
                    placeholder="Carter"
                    onChange={(event) => setLast_name(event.target.value)}
                    inputProps={{ maxLength: 30 }}
                    required
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    type='tel'
                    size='small'
                    label="Teléfono"
                    placeholder="6011234567"
                    onChange={(event) => setPhone(event.target.value)}
                    inputProps={{ maxLength: 10 }}
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    type='tel'
                    label="Celular"
                    size='small'
                    placeholder="3101234567"
                    onChange={(event) => setCellphone(event.target.value)}
                    inputProps={{ maxLength: 10 }}
                    required
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      name="new-pass-field"
                      label=""
                      size='small'
                      type="password"
                      placeholder="Password"
                      onChange={(event) => setPassword(event.target.value)}
                      inputProps={{ maxLength: 30 }}
                      required
                      autoComplete="new-password"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      name="confirm-pass-field"
                      label=""
                      size='small'
                      type='password'
                      placeholder="Confirm Password"
                      onChange={(event) => setPassword_confirm(event.target.value)}
                      inputProps={{ maxLength: 30 }}
                      required
                      autoComplete="new-password"
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>

            <Divider sx={{ margin: 0 }} />
            <CardActions>
              <Button
                size="small"
                type="submit"
                sx={{ mr: 2 }}
                variant="contained"
                onClick={submit}
              >
                Guardar
              </Button>
              <Link to="/administrar/empleados">
                <Button size="small" color="secondary" variant="outlined">
                  Cancelar
                </Button>
              </Link>
            </CardActions>
          </form>
        </CardContent>
      </Card>
    </HeaderResponsive>

  );
}

export default UserAdd;
